import { useState, useEffect } from 'react';
import { formatDistanceToNow } from 'date-fns';

/**
 * Hook for auto-refreshing timestamps
 * Updates relative time display (e.g., "2 minutes ago") at regular intervals
 */
export const useDynamicTimestamp = (date: Date | null, intervalMs: number = 60000) => {
  const [timestamp, setTimestamp] = useState<string>('');

  useEffect(() => {
    if (!date) {
      setTimestamp('');
      return;
    }

    const updateTimestamp = () => {
      setTimestamp(formatDistanceToNow(date, { addSuffix: true }));
    };

    // Initial update
    updateTimestamp();

    // Set up interval for updates
    const interval = setInterval(updateTimestamp, intervalMs);

    return () => clearInterval(interval);
  }, [date, intervalMs]);

  return timestamp;
};